var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataflow01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.3334H11.2C10.0799 13.3334 9.51984 13.3334 9.09202 13.1154C8.71569 12.9236 8.40973 12.6177 8.21799 12.2414C8 11.8135 8 11.2535 8 10.1334V5.86671C8 4.7466 8 4.18655 8.21799 3.75873C8.40973 3.3824 8.71569 3.07644 9.09202 2.88469C9.51984 2.66671 10.0799 2.66671 11.2 2.66671H11.3333M11.3333 13.3334C11.3333 14.0698 11.9303 14.6667 12.6667 14.6667C13.403 14.6667 14 14.0698 14 13.3334C14 12.597 13.403 12 12.6667 12C11.9303 12 11.3333 12.597 11.3333 13.3334ZM11.3333 2.66671C11.3333 3.40309 11.9303 4.00004 12.6667 4.00004C13.403 4.00004 14 3.40309 14 2.66671C14 1.93033 13.403 1.33337 12.6667 1.33337C11.9303 1.33337 11.3333 1.93033 11.3333 2.66671ZM4.66667 8.00004L11.3333 8.00004M4.66667 8.00004C4.66667 8.73642 4.06971 9.33337 3.33333 9.33337C2.59695 9.33337 2 8.73642 2 8.00004C2 7.26366 2.59695 6.66671 3.33333 6.66671C4.06971 6.66671 4.66667 7.26366 4.66667 8.00004ZM11.3333 8.00004C11.3333 8.73642 11.9303 9.33337 12.6667 9.33337C13.403 9.33337 14 8.73642 14 8.00004C14 7.26366 13.403 6.66671 12.6667 6.66671C11.9303 6.66671 11.3333 7.26366 11.3333 8.00004Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataflow01);
export default __webpack_public_path__ + "static/media/dataflow-01.b5a4bd7df5739b2c1fb6634d8f225f45.svg";
export { ForwardRef as ReactComponent };